const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

function getToken() {
  return localStorage.getItem('token');
}

// Expired/invalid session → clear storage and send the user to login once,
// instead of every page silently breaking on stale data.
function handleUnauthorized() {
  if (!getToken()) return; // login attempt failures are handled by the page
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  if (!window.location.pathname.startsWith('/login')) {
    window.location.href = '/login?expired=1';
  }
}

async function apiFetch(path, options = {}) {
  const token = getToken();
  const isFormData = options.body instanceof FormData;
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(!isFormData && options.body ? { 'Content-Type': 'application/json' } : {}),
    ...options.headers,
  };
  const response = await fetch(`${BASE_URL}${path}`, { ...options, headers });

  // Auth endpoints return 401 for wrong credentials — only force logout when
  // an existing session token is rejected on a non-auth route.
  if (response.status === 401 && token && !path.startsWith('/api/auth/login') && !path.startsWith('/api/auth/signup')) {
    handleUnauthorized();
  }

  return response;
}

export const api = {
  get:    (path, opts = {})       => apiFetch(path, { ...opts, method: 'GET' }),
  post:   (path, body, opts = {}) => apiFetch(path, { ...opts, method: 'POST',  body: body instanceof FormData ? body : JSON.stringify(body) }),
  put:    (path, body, opts = {}) => apiFetch(path, { ...opts, method: 'PUT',   body: JSON.stringify(body) }),
  patch:  (path, body, opts = {}) => apiFetch(path, { ...opts, method: 'PATCH', body: JSON.stringify(body) }),
  delete: (path, opts = {})       => apiFetch(path, { ...opts, method: 'DELETE' }),
};
